<template>
  <div class="things-banner">
    <img :src="thingsBanner" alt="" />
    <div class="absolute">
      <div class="title">物联网硬件系统</div>
      <div class="text">智慧物业通过智能感知硬件：无人门岗、人脸识别、车辆识别、水电煤监测、电梯监测、高空抛物监测、垃圾分类监控、访客自动登记、自动测温等。通过AI算法形成业务闭环，节约物业人工成本，打通软硬件壁垒，实现现代智能化物业管理的一种新型物管模式。</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience v-if="experienceShow" :experienceShow="experienceShow" @experienceClick="experienceClick"></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from '../../../../components/pc/components/Experience.vue'

import thingsBanner from '../../../../assets/product/thingsBanner.png'

export default {
  setup() {
    return reactive({
      thingsBanner:thingsBanner,
      experienceShow: false
    })
  },
   components: {
    Experience
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow
    }
  },
};
</script>

<style scoped>
.things-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .things-banner {
    min-width: 1180px;
  }
}
.things-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 33%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #fff;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #fff;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
